module.exports = __webpack_public_path__ + "static/media/support4.98857230.png";